/* eslint-disable linebreak-style */
export default {
    root: {
      paddingTop: '0px'
    }
  };
